import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ElementType, ReactNode } from 'react'
import { IconFa, Text, TextProps } from '../../atoms'

export const DisclosureWithButton = ({
  children,
  text,
  as,
  defaultOpen,
  buttonTextProps
}: {
  as?: ElementType
  defaultOpen?: boolean
  buttonTextProps?: Omit<TextProps, 'children'>
  text: ReactNode
  children: ReactNode
}) => (
  <Disclosure as={as ?? 'div'} defaultOpen={defaultOpen} className="w-full">
    {({ open }) => (
      <>
        <DisclosureButton>
          <Text textType="lg" className="ml-2" as="h3" {...buttonTextProps}>
            <IconFa icon={['far', open ? 'chevron-down' : 'chevron-right']} className="mr-2 w-4" />
            {text}
          </Text>
        </DisclosureButton>
        <DisclosurePanel>{children}</DisclosurePanel>
      </>
    )}
  </Disclosure>
)
